import Vue from 'vue';

export default {
  state: {
    mainPage: {
      firstSection: {
        title: '',
        preview: { url: '' },
        imagePreview: { url: '' },
      },
      secondSection: {
        preview: { url: '' },
        imagePreview: { url: '' },
      },
      thirdSection: {
        preview: { url: '' },
        imagePreview: { url: '' },
      },
      fourthSection: {
        title: '',
        description: '',
        floors: '',
        apartments: '',
        parking: '',
        area: '',
        preview: { url: '' },
      },
      fifthSection: {
        title: '',
        preview: { url: '' },
        mobilePreview: { url: '' },
      },
      sixthSection: {
        title: '',
        preview: { url: '' },
        options: [],
      },
      seventhSection: {
        title: '',
        partners: [],
      },
    },
  },
  mutations: {
    setMainPage(state, data) {
      state.mainPage = data;
    },
  },
  actions: {
    async getMainPage(store) {
      const path = 'main-page';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setMainPage', resp.data);
        return resp.data;
      });
    },
  },
};
